import React from 'react';
import styled from '@emotion/styled';
import phrasesType from '../proptypes/phrases';
import profileWithArchetypeType from '../proptypes/profile-with-archetype';
import selectComparisonTableData from '../selectors/comparison-table-data';
import AttributesTable from './AttributesTable';
import { Header4 } from './Typography';

const CompareSectionHeading = styled(Header4)`
  margin-bottom: 2rem;
`;

const ComparisonPreviewTable = ({
  currentProfile,
  comparedProfile,
  phrases: {
    comparison: {
      attributesSection,
    },
  },
  phrases,
}) => {
  const comparisonTableData = selectComparisonTableData(
    currentProfile,
    comparedProfile,
    phrases,
  );
  const { attributes } = comparisonTableData;

  return (
    <div data-testid="comparison-preview-table">
      <CompareSectionHeading>{attributesSection.title}</CompareSectionHeading>
      <AttributesTable data={attributes} />
    </div>
  );
};

ComparisonPreviewTable.propTypes = {
  currentProfile: profileWithArchetypeType.isRequired,
  comparedProfile: profileWithArchetypeType.isRequired,
  phrases: phrasesType.isRequired,
};

export default ComparisonPreviewTable;
